<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden")
  kubiqa-website-themes-theme-e-components-shared-top-navigation(class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-z-10")
  v-row(align="middle" justify="center" class="tw-z-0 tw-mt-3")
    v-col(cols="12")
      v-parallax(
        height="550"
        :src="website.pages.home.background_image ? path(website.pages.home.background_image) : ''"
        class="theme-e-parallax"
      )
        v-row(no-gutters align="end" class="py-0 my-0")
          v-col
            v-row(no-gutters align="center" justify="space-around")
              v-col(cols="12")
                div(class="tw-grid")
                  div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
                    kubiqa-website-shared-widget-editor(
                      page="home"
                      placement="call_out"
                      @content="(content) => (content != null ? ((defaultCallout = false), key++) : ((defaultCallout = true), key++))"
                    )
                  div(
                    v-if="defaultCallout"
                    :key="key"
                    class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle"
                  )
                    div(class="tw-h-full  tw-items-center tw-flex")
                      v-row(no-gutters justify="center")
                        v-col(cols="9")
                          span(class="tw-font-bold tw-text-white tw-text-2xl") Find your ideal home
            v-row(justify="center" align="end" class="tw-mb-20")
              v-col(cols="10")
                kubiqa-website-themes-theme-e-components-shared-floating-search-bar
  v-row(no-gutters align="center" justify="space-around" class="tw-pt-20 tw-pb-10")
    v-col(cols="12")
      div(class="tw-grid")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
          kubiqa-website-shared-widget-editor(
            page="home"
            placement="description"
            @content="(content) => (content != null ? ((defaultDescription = false), key++) : ((defaultDescription = true), key++))"
          )
        div(v-if="defaultDescription" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
          div(class="tw-h-full  tw-items-center tw-flex")
            v-row(no-gutters justify="center")
              v-col(cols="9")
                span(class="tw-font-bold tw-text-white tw-text-2xl") Description
  kubiqa-website-themes-theme-e-components-home-listings
  v-row
    v-col
  kubiqa-website-themes-theme-e-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      key: 0,
      defaultCallout: null,
      defaultDescription: null,
    };
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
<style lang="scss">
.theme-e-parallax .v-parallax__content {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
